import { Component, Emit, Prop, Watch } from 'vue-property-decorator';
import JhiDataUtils from '@/shared/data/data-utils.service';
import { mixins } from 'vue-class-component';
import ApeironComponent from '@/components/commons/apeiron-component.model';
import { Solucion } from '@/shared/model/solucion.model';
import { Solicitud } from '@/shared/model/solicitud.model';
import { required } from 'vuelidate/lib/validators';
import { GeneracionSnp } from '@/shared/model/snp/generaciones.model';
import { v4 as uuidv4 } from 'uuid';
import { obtenerFechaHoyYYYYMMDD } from '@/shared/date/date-utils';

const validations = function () {
  return {
    generacion: {
      fechaGeneracion: required,
    },
  };
};

@Component({ validations: validations })
export default class GeneracionesRegistroComponent extends mixins(JhiDataUtils, ApeironComponent) {
  @Prop({ required: true })
  public readonly solucion: Solucion;

  @Prop({ required: true })
  public readonly solicitud: Solicitud;

  @Prop({
    required: false,
    default: function () {
      return new GeneracionSnp();
    },
  })
  public readonly generacionEdicion: GeneracionSnp;

  public generacion: GeneracionSnp = new GeneracionSnp();
  public fechaHoy = '';

  public mounted(): void {
    this.iniciarComponente(true);
  }

  @Watch('generacionEdicion')
  public watchGeneracionEdicion(): void {
    this.iniciarComponente(false);
  }

  public iniciarComponente(esFormLimpio: boolean): void {
    this.fechaHoy = obtenerFechaHoyYYYYMMDD();
    this.generacion = new GeneracionSnp();

    if (this.generacionEdicion?.id && !esFormLimpio) {
      this.generacion = GeneracionSnp.fromObject(this.generacionEdicion);
    } else {
      this.generacion = new GeneracionSnp();
      this.generacion.id = uuidv4();
    }
  }

  public limpiarDatos(): void {
    this.iniciarComponente(true);
  }

  public guardarGeneracion(): void {
    if (!this.formularioIsInvalid) {
      if (this.esEscritura) {
        if (this.yaExisteLaFecha()) {
          this.alertService().showWarning(this, this.$t('apeironGwApp.generacionesSnp.form.fechaDuplicada').toString());
        } else {
          this.registrarGeneracion();
        }
      }
    } else {
      this.alertService().showWarning(this, this.$t('apeironGwApp.generacionesSnp.form.formularioInvalido').toString());
    }
  }

  @Emit('guardarGeneracion')
  public registrarGeneracion(): Array<GeneracionSnp> {
    const generacion = GeneracionSnp.fromObject(this.generacion);
    const generaciones = this.solicitud.generaciones ?? [];

    generaciones.push(generacion);

    this.limpiarDatos();

    return generaciones;
  }

  get formularioIsInvalid(): boolean {
    return this.$v.$invalid;
  }

  private yaExisteLaFecha(): boolean {
    return !!(this.solicitud.generaciones ?? []).find(generacion => generacion.fechaGeneracion == this.generacion.fechaGeneracion);
  }

  /**
   * Indicador para permitir el modo escritura
   */
  get esEscritura(): boolean {
    return this.esEscrituraConEstadoEnCaptura(this.solicitud.estado);
  }
}
